let mouseDown = null;

const initSelects = () => {
    const selects = document.querySelectorAll(".InputfieldSelectCustom");
    selects.forEach((container, index) => {
        //const options = container.querySelectorAll(".select > label");
        //let value = container.querySelector("summary .value-text").textContent;

        setAria(container);
        addListeners(container);
    });
};

const setAria = (container) => {
    container.setAttribute("aria-haspopup", "listbox");
    const selectBox = container.querySelector(".select");
    selectBox.setAttribute("role", "listbox");
    selectBox.querySelector("[type=radio]").setAttribute("role", "option");
};

const addListeners = (container) => {
    const options = container.querySelectorAll(".select > label");

    container.addEventListener("toggle", () => {
        if (container.open) return;
        const value = container.querySelector("summary .value-text")
            .textContent;
        updateValue(container, value);
    });

    container.addEventListener("focusout", (e) => {
        console.log(mouseDown);
        if (mouseDown == container) return;
        container.removeAttribute("open");
    });

    options.forEach((opt) => {
        opt.addEventListener("mousedown", () => {
            mouseDown = container;
        });
        opt.addEventListener("mouseup", () => {
            mouseDown = null;
            container.removeAttribute("open");
        });
    });

    /*document.addEventListener("keyup", (e) => {
        const key = e.key;
        console.log(key);
        switch (key) {
            case "ArrowDown":
            case "ArrowUp":
                e.preventDefault();
                break;
        }
    });*/

    window.addEventListener(
        "keydown",
        (e) => {
            if (document.querySelector(".InputfieldSelectCustom[open]")) {
                // if you need to filter <input> elements
                switch (e.keyCode) {
                    case 38: // up
                    case 40: // down
                        e.preventDefault();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            //capture: true, // this disables arrow key scrolling in modern Chrome
            //passive: false, // this is optional, my code works without it
        }
    );

    container.addEventListener("keyup", (e) => {
        console.log(e.which);
        const keycode = e.which;
        const current = [...options].indexOf(
            container.querySelector(".active")
        );
        console.log(current);
        switch (keycode) {
            case 27: // ESC
                container.removeAttribute("open");
                break;
            case 35: // END
                e.preventDefault();
                if (!container.open) container.setAttribute("open", "");
                setChecked(
                    container,
                    options[options.length - 1].querySelector("input")
                );
                break;
            case 36: // HOME
                e.preventDefault();
                if (!container.open) container.setAttribute("open", "");
                setChecked(container, options[0].querySelector("input"));
                break;
            case 38: // UP
                e.preventDefault();
                if (!container.open) container.setAttribute("open", "");
                setChecked(
                    container,
                    options[current > 0 ? current - 1 : 0].querySelector(
                        "input"
                    )
                );
                break;
            case 40: // DOWN
                console.log("down");
                e.preventDefault();
                if (!container.open) container.setAttribute("open", "");
                setChecked(
                    container,
                    options[
                        current < options.length - 1
                            ? current + 1
                            : options.length - 1
                    ].querySelector("input")
                );
                break;
        }
    });
};

const updateValue = (container, oldVal) => {
    const checkedInput = container.querySelector("input:checked");
    if (!checkedInput) return;
    setValue(container, checkedInput, oldVal);
};

const setValue = (container, checkedInput, oldVal) => {
    const newVal = checkedInput.value;
    if (newVal == oldVal) return;

    container.querySelector("summary .value-text").textContent = newVal;
    //oldVal = newVal;

    const options = container.querySelectorAll(".select > label");
    options.forEach((opt) => {
        opt.classList.remove("active");
    });
    checkedInput.parentNode.classList.add("active");
    container.classList.add("is-selected");
    container.dispatchEvent(new Event("change"));
};

const setChecked = (container, input) => {
    const oldVal = container.querySelector("summary .value-text").textContent;
    input.checked = true;
    setValue(container, input, oldVal);
};

if (document.querySelector(".InputfieldSelectCustom")) initSelects();
/*
const selects = document.querySelectorAll(".InputfieldSelect");
let isOpen = false;
selects.forEach((selectEl, index) => {
    const selectedOptionEl = selectEl.querySelector(".selected-option");
    if (!selectedOptionEl) return;
    const selectedValueEl = selectEl.querySelector(".selected-value");
    const options = selectEl.querySelectorAll(".select-option");

    selectedOptionEl.addEventListener("click", (e) => {
        toggleOptions(selectEl);
    });

    selectEl.addEventListener("blur", (e) => {
        toggleOptions(selectEl);
    });

    options.forEach((optionEl, index) => {
        optionEl.addEventListener("click", (e) => {
            selectedOptionEl.querySelector(".value-text").innerHTML =
                e.target.innerHTML;
            selectedValueEl.value = e.target.innerHTML;
            selectEl.classList.add('is-selected');
            toggleOptions(selectEl);
            //selectEl.querySelector(".select-list").blur();
        });
    });
});

const toggleOptions = (el) => {
    isOpen = !isOpen;
    if (isOpen) {
        el.classList.add("is-open");
        //el.querySelector(".select-list").focus();
    } else {
        el.classList.remove("is-open");
        //el.querySelector(".select-list").blur();
    }
};
*/

/*
var isOpen = false;

function toggleOptions(e) {
    isOpen = !isOpen;
    if (isOpen) {
        document.getElementById("selectContainer").style.visibility = "visible";
        document.getElementById("selectContainer").focus();
    } else {
        document.getElementById("selectContainer").blur();
        document.getElementById("selectContainer").style.visibility = "hidden";
    }
}

const selected = (val) => {
    document.getElementById("valueText").innerHTML = val;
    document.getElementById("selectedValue").val = val;
    toggleOptions();
};
*/
